/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatbotSettingsOverrides } from './ChatbotSettingsOverrides';
import {
    ChatbotSettingsOverridesFromJSON,
    ChatbotSettingsOverridesFromJSONTyped,
    ChatbotSettingsOverridesToJSON,
    ChatbotSettingsOverridesToJSONTyped,
} from './ChatbotSettingsOverrides';
import type { SearchSettingsOverrides } from './SearchSettingsOverrides';
import {
    SearchSettingsOverridesFromJSON,
    SearchSettingsOverridesFromJSONTyped,
    SearchSettingsOverridesToJSON,
    SearchSettingsOverridesToJSONTyped,
} from './SearchSettingsOverrides';

/**
 * 
 * @export
 * @interface ChatSettingsOverrides
 */
export interface ChatSettingsOverrides {
    /**
     * 
     * @type {SearchSettingsOverrides}
     * @memberof ChatSettingsOverrides
     */
    searchSettingsOverrides: SearchSettingsOverrides;
    /**
     * 
     * @type {ChatbotSettingsOverrides}
     * @memberof ChatSettingsOverrides
     */
    chatbotSettingsOverrides: ChatbotSettingsOverrides;
    /**
     * 
     * @type {string}
     * @memberof ChatSettingsOverrides
     */
    responseLanguage?: string | null;
}

/**
 * Check if a given object implements the ChatSettingsOverrides interface.
 */
export function instanceOfChatSettingsOverrides(value: object): value is ChatSettingsOverrides {
    if (!('searchSettingsOverrides' in value) || value['searchSettingsOverrides'] === undefined) return false;
    if (!('chatbotSettingsOverrides' in value) || value['chatbotSettingsOverrides'] === undefined) return false;
    return true;
}

export function ChatSettingsOverridesFromJSON(json: any): ChatSettingsOverrides {
    return ChatSettingsOverridesFromJSONTyped(json, false);
}

export function ChatSettingsOverridesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatSettingsOverrides {
    if (json == null) {
        return json;
    }
    return {
        
        'searchSettingsOverrides': SearchSettingsOverridesFromJSON(json['searchSettingsOverrides']),
        'chatbotSettingsOverrides': ChatbotSettingsOverridesFromJSON(json['chatbotSettingsOverrides']),
        'responseLanguage': json['responseLanguage'] == null ? undefined : json['responseLanguage'],
    };
}

export function ChatSettingsOverridesToJSON(json: any): ChatSettingsOverrides {
    return ChatSettingsOverridesToJSONTyped(json, false);
}

export function ChatSettingsOverridesToJSONTyped(value?: ChatSettingsOverrides | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'searchSettingsOverrides': SearchSettingsOverridesToJSON(value['searchSettingsOverrides']),
        'chatbotSettingsOverrides': ChatbotSettingsOverridesToJSON(value['chatbotSettingsOverrides']),
        'responseLanguage': value['responseLanguage'],
    };
}

